import axios from 'axios';
import { API_BASE_URL, TENNIS_RU_BASE_URL } from './config';

const instance = axios.create({
  baseURL: API_BASE_URL,
});

// Добавляем токен к каждому запросу
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Обрабатываем ошибки авторизации
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Tennis.ru API instance with Basic authentication
const tennisInstance = axios.create({
  baseURL: TENNIS_RU_BASE_URL,
});

tennisInstance.interceptors.request.use((config) => {
  config.auth = {
    username: 'Webservice',
    password: 'rheujvdhfub'
  };
  config.headers['Content-Type'] = 'application/json';
  return config;
});

export default instance;
export { tennisInstance }; 